import React from "react";
import { Card } from "antd";
import styled from "styled-components";
import { brides } from "../data/data";
import { HeartFilled } from "@ant-design/icons";

const Layout = styled.div`
  font-family: "Oswald", sans-serif;
  .card-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    padding: 50px 15%;
    grid-gap: 30px;
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      padding: 40px 5%;
    }
    @media (width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      padding: 40px 5%;
    }
  }
  .card-wrapper img {
    width: 100%;
    object-fit: cover;
  }
  .circle {
    background: #f6f6f6;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    color: red;
  }
  .icon-container {
    margin-top: -47px;
  }
`;

const { Meta } = Card;
function Maids() {
  return (
    <>
      <Layout>
        <div className="card-wrapper">
          {brides &&
            brides.map((bride) => {
              return (
                <div style={styles.container} key={bride.id}>
                  <Card
                    hoverable
                    cover={
                      <img
                        alt="example"
                        src={bride.imgUrl}
                        style={{ height: 284 }}
                        className="grow"
                      />
                    }
                  >
                    <div
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <div className="icon-container">
                        <span className="circle">
                          <HeartFilled />
                        </span>
                      </div>

                      <div style={{ marginTop: 15 }}>
                        <Meta title={bride.title} />
                        <p style={{ paddingTop: 12 }}>{bride.desc}</p>
                      </div>
                    </div>
                  </Card>
                </div>
              );
            })}
        </div>
      </Layout>
    </>
  );
}
const styles = {
  container: {
    marginBottom: 25,
  },
};

export default Maids;
